import { RefElement } from 'widgets/toolbox/RefElement';

/**
 * @description CoreProductVideo implementation
 * @param ProductVideo Base widget for extending
 * @returns CoreProductVideo widget
 */
function CoreProductVideoClassCreator(ProductVideo: import('widgets/product/ProductVideo').TProductVideo) {
    /**
     * @category widgets
     * @subcategory product
     * @class Video
     * @augments Widget
     * @classdesc Represents Video component with autostart. Allows watching video after pressing "Video" thumbnail.
     */

    class CoreProductVideo extends ProductVideo {
        /**
         * @description Add an activated styling to the video thumbnail and start to show video
         * @param el - event source element
         * @emits "showvideo"
         */
        showVideo(el: RefElement) {
            this.emit('showvideo');
            el.addClass(this.prefs().videoThumbnailActiveClass);
        }
    }

    return CoreProductVideo;
}

export type TCoreProductVideo = ReturnType<typeof CoreProductVideoClassCreator>;

export type TCoreProductVideoInstance = InstanceType<TCoreProductVideo>;

export default CoreProductVideoClassCreator;
